import React from "react";
import { CardContentType, CardDatumType, LanguageEnum } from "../../types";
import { translateText } from "../translations";

interface MockCardProps {
  content: CardContentType | null;
  language: LanguageEnum;
  //height?: string | number;
}

const MockCard: React.FC<MockCardProps> = ({ content, language }) => {

  const getDisplayValue = (data: CardContentType | null, field: keyof CardContentType): string => {
    if (!data || !data[field] || data[field]?.length === 0) return `[${language !== "japanese" ? "No" : ""} ${translateText(field, language)}${language === "japanese" ? "なし" : ""}]`;
    const datum = data[field] as CardDatumType[];
    const valueByLang = datum.find((item) => item.language === language);
    if (valueByLang) return valueByLang.content;
    const valueWithoutLang = datum.find((item) => item.language === null);
    if (valueWithoutLang) return valueWithoutLang.content;
    return datum[0].content;
  };

  const companyName = getDisplayValue(content, "companyName");
  const branch = getDisplayValue(content, "branch");
  const firstName = getDisplayValue(content, "firstName");
  const lastName = getDisplayValue(content, "lastName");
  const fullName = language === "japanese" ? `${lastName} ${firstName}` : `${firstName} ${lastName}`;
  const email = getDisplayValue(content, "email");
  const phone = getDisplayValue(content, "phone");

  return (
    <div
  className="flex flex-col aspect-[5/3] w-full bg-[url('/MockCardBgr.svg')] bg-no-repeat bg-cover bg-center border border-solid border-gray-400 drop-shadow-lg"
>
      <div className="flex-1 p-4 flex flex-col justify-between">
       
        <div className="flex flex-col items-end text-base">
          <div className="font-bold">{companyName}</div>
          <div className="font-normal mt-[-3px]">{branch}</div>
        </div>

       
        <div className="flex flex-col justify-end text-sm">
          <div className="font-bold text-2xl">{fullName}</div>
          <div className="w-full h-[2px] bg-gradient-to-r from-sky-600 to-transparent mt-1 mb-1" />
          <div>{email}</div>
          <div>{phone}</div>
        </div>
      </div>
    </div>
  );
};

export default MockCard;
